import React, {useState} from 'react';
import SkeletonFormField from "./skeleton-form-field";
import {ReactComponent as EyeIcon} from "@assets/icons/eye-1.svg";
import {ReactComponent as EyeSlashIcon} from "@assets/icons/eye-2.svg";
import {useFormContext} from "react-hook-form";

interface PasswordFormFieldProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
    name: string;
    label: string;
    className?: string;
    isLoading?: boolean;
    showPasswordToggle?: boolean;
}

const PasswordFormField: React.FC<PasswordFormFieldProps> = (props: PasswordFormFieldProps) => {
    const {register, formState: {errors, isSubmitting}} = useFormContext();
    const {
        name,
        label,
        className = '',
        isLoading,
        showPasswordToggle = true,
        ...rest
    } = props;

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className='w-full'>
            <div className={`relative w-full h-fit`}>
                <label htmlFor={name} className="text-[14px] font-semibold block mb-2 leading-[1.125rem] text-on-surface/80">
                    {label}
                </label>
                {isLoading
                    ? <div className='pt-6 px-3'><SkeletonFormField/></div>
                    : <>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            id={name}
                            {...register(name)}
                            placeholder="Write"
                            className={`text-[14px] max-h-[40px] border border-outline bg-surface-level-1 rounded-lg px-3 py-[11px] pr-14 appearance-none w-full focus:outline-none focus:ring-2 focus:ring-primary ${errors[name] ? 'border border-red-400 focus:ring-red-400' : 'border-gray-300 focus:ring-primary_400'} ${className}`}
                            disabled={isSubmitting}
                            {...rest}
                        />
                        {showPasswordToggle && (
                            <div
                                className="absolute top-[28px] right-[2px] pr-0 flex items-center cursor-pointer"
                                onClick={togglePasswordVisibility}
                            >
                                {showPassword ? (
                                    <div className='bg-surface-level-1 rounded-lg w-9 h-9 flex items-center justify-center'>
                                        <EyeSlashIcon
                                            className={`h-fit w-[0.875rem] ${errors[name] ? 'text-red-500' : 'text-on-surface/80'}`}
                                        />
                                    </div>
                                ) : (
                                    <div className='bg-surface-level-1 rounded-lg w-9 h-9 flex items-center justify-center'>
                                        <EyeIcon
                                            className={`h-fit w-[0.875rem] ${errors[name] ? 'text-red-500' : 'text-on-surface/80'}`}
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </>
                }
            </div>
            {errors[name] && <p className="text-red-500 text-xs px-3 pt-1">{'' + errors[name]?.message}</p>}
        </div>
    );
};

export default PasswordFormField;
